import React, { useEffect, useState } from 'react'

import axios from 'axios'


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {   faPlus, prefix } from '@fortawesome/free-solid-svg-icons'

import { ApiCallPost ,ApiCallGet } from '../../ApiCall/ApiCall'

import AddClient from '../../AddClient/AddClient'


import Modal from 'react-modal';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor :'#FFF9E2' ,
    borderRadius : '10px' ,
    width :'800px' ,
    

  },
};

const customStyles2 = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor :'#E6FFFB' ,
      borderRadius : '10px' ,
      width :'400px' ,
      
  
    },
  };
  



function AddThird( {code ,exitadd , naturaleza }) {

    const [value,setValue] = useState( "" )
    const [codigos,setCodigos] = useState( [] )
    const [nameCodigo,setNameCodigo] = useState( "") ;
    const [cero,setCero] = useState( "")

    const [tipo,setTipo] = useState( "R")

    const [showCliente,setShowCliente] = useState( false ) ;

    const [theData,setTheData] = useState( [] )
    const [showAddClient,setShowAddClient] = useState( false ) ;

    const [clientTitle,setClientTitle] = useState("")


    const [modalIsOpen, setIsOpen] = useState(false);
    let subtitle = {};


    const [modalIsOpen2, setIsOpen2] = useState(false);
    let subtitle2 = {};

    const [message,setMessage] = useState( "")
  
  
  
    function openModal() {
      setIsOpen(true);
    }
  
    function afterOpenModal() {
      // references are now sync'd and can be accessed.
      subtitle.style.color = '#28A7F1' ;  //'#f00';
    } // E6FFFB
  
    function afterOpenModal2() {
        // references are now sync'd and can be accessed.
        subtitle.style.color = '#28A7F1' ;  //'#f00';
      } // E6FFFB
    
    function closeModalReject()
    {
      setIsOpen( false ) ;
    }
    // Charly
    function closeAccept()
    {
        document.getElementById( "theDiv").hidden =  false ;
        setIsOpen2(false);


        handleGuardarPrev()
    }

    function closeReject()
    {
        document.getElementById( "theDiv").hidden =  false ;
        setIsOpen2(false);
    }
    function closeModal() {
      setIsOpen(false);
    }

    function closeModal2() {
        document.getElementById( "theDiv").hidden =  false ;
        setIsOpen2(false);
      }
  
  
  
    function onAddSelected() // Se solicita agregar al candidato
    {
      console.log( "onAddSelected")
    }
  


    // Charly
    function onCloseClient()
    {
        //setShowAddClient( false ) ;
        document.getElementById( "theDiv").hidden =  false ; 
        setIsOpen( false )
    }

    function onAddClient()
    {
        console.log( "setShowClient")
        //setShowAddClient( true ) ;
        document.getElementById( "theDiv").hidden =  true ; 
        setIsOpen( true )
    }

    function onChangeSelect()
    {

        var e1 = document.getElementById('select') ;
    
    
        //var text = e1.options[e1.selectedIndex].text;


        //setData( dataArray[e1.selectedIndex])


        document.getElementById( "tercer").value = theData[e1.selectedIndex].rfc.substring( 0 , 4 )
        document.getElementById( "nombre").value = theData[e1.selectedIndex].nombre  + " "  +  theData[e1.selectedIndex].appaterno  + " " +  theData[e1.selectedIndex].apmaterno  ;

    }

    function askBefore()
    {
        document.getElementById( "theDiv").hidden =  true ; 
        setMessage( "Esta cuenta se agregara con Tipo " + (tipo==="R" ? "Resumen" : "Detalle") )
        setIsOpen2( true )


    }

   
    async function handleGuardarPrev()
    {

        if ( code === "201.01" || code === "502.01" || code === "118.01") // Proveedores
        {
            //var codeArray =¶1" ] ;

            var codeArray = [ 
                { code : "201.01" , nivel : "3" , prefix : "" , naturaleza : "A" } , // Detalle depende de sus hermanos
                { code : "502.01" , nivel : "4" , prefix : "¶" , naturaleza : "D" } ,
                { code : "118.01" , nivel : "4" , prefix : "¶" , naturaleza : "D" }
            ]
            for( var i = 0 ; i < codeArray.length ; i++ )
            {
                await handleGuardar( codeArray[i] , true ) ;
            }

            return ;

        }

        await handleGuardar( code , false )

    }
/*

100 Deudoras
200 Acredoras
300 Acredoras
400 A/D  Todas son A , excepto 402 ( D )
500 A/D ( 503 , 504 son A ) otras son deudoras
600 Deudoras
700 A/D  ( 701 D , 702 A , 703 D ,  704 A  )
800 A/D  ( 801 , 802 , 803 , 804 ) Terminadoen en Non son D , y par es A

*/

    function handleGuardar(code2 , filter = false )
    {

        return new Promise (( resolve,reject) => {

            console.log( "code + value = " + code2 + value )

            console.log( "Nombre = " + document.getElementById("nombre").value  )

            var obj = {
                nivel : ( filter ? code2.nivel : "3"  ),
                parent : ( filter ? code2.code : code2  ),
                second :  ( filter ? code2.code + code2.prefix + value : code2 + value ) ,
                name : document.getElementById("nombre").value ,
                naturaleza : ( filter ? code2.naturaleza : naturaleza ) ,
                tipo : tipo , // Poner un state
                comment : document.getElementById("comentario").value ,
                dTimeStamp : getFormatDate( new Date() )
            }

            console.log( "handleGuardar =  " + JSON.stringify( obj ) ) ;


            ApiCallPost( "savesecond" , obj )
            .then((result) => {
                console.log( "result " + JSON.stringify( result ) ) ;
                //return ;
                resolve() ;
                return ;
            })
            .catch((err) => {
                console.log( err ) ;
                resolve() ;
                return ;
            })

        })
    }

    function getFormatDate(d) {
        var date = new Date(d);
        var dateStr =
            date.getFullYear() + "-" +
            ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
            ("00" + date.getDate()).slice(-2) + " " +
            ("00" + date.getHours()).slice(-2) + ":" +
            ("00" + date.getMinutes()).slice(-2) + ":" +
            ("00" + date.getSeconds()).slice(-2);
        //console.log(dateStr);
    
        return dateStr;
    }
    

    function handleOnChange( val)
    {
        //console.log( "onChange val = " + JSON.stringify( value ) )

        var value = document.getElementById( "tercer").value ;

        console.log( "Value = " + value ) ;

        setValue( value ) ;



    }


    function showSelect( dataArray)
    {
        setTheData( dataArray )

        var select = document.getElementById('select') ;


        while( select.length > 0 )
        {
            select.remove( select.length -1 ) ;
        }


        for( var i = 0 ; i < dataArray.length ; i++)
        {
            

            var option = document.createElement("option");
            option.value = dataArray[i].rfc ;
            option.text = dataArray[i].rfc + " => " + dataArray[i].nombre  + " "  +  dataArray[i].appaterno  + " " +  dataArray[i].apmaterno  ;   ;
            select.appendChild(option)


        }



    }


    useEffect(() => {

        if ( code === "105.01" || code === "201.01" || code === "502.01" || code === "118.01" ||
            code === "118.01" || code === "601"  ) // 502.01 pi  , 118.01 pi ( yuan ) //Elegir la cuenta en forma disvrecionañ// 601 yuan analizar
        {
            if ( code=== "105.01")
            {
                setClientTitle( "Cliente")
            }

            if ( code === "201.01" ||  code === "502.01" || code === "118.01" ) // Revisar proveedores
            {
                setClientTitle("Proveedor")
            }

            if ( code.substring(0,3) === "601")
            {
                // Do something // Que tipo de gato es ( iva 118.01 yuan )

                setClientTitle( "Gastos")
            }

            document.getElementById( "theDiv").style.width =  "600px"   
            
            ApiCallGet( "getclientes")
            .then(( response ) => {

                console.log( "response = " + response.length )

                showSelect( response ) ;


                console.log( "theData = " + response[0].rfc )


            
                document.getElementById( "tercer").value = response[0].rfc.substring( 0 , 4 )
                document.getElementById( "nombre").value = response[0].nombre  + " "  +  response[0].appaterno  + " " +  response[0].apmaterno  ;
        


                //setTimeout( onChangeSelect , 500 )

                //onChangeSelect() ;

            })
            .catch((err) => {
                console.log( err )
            })

            setShowCliente( true ) ;
            
        }

    axios.get('http://localhost:3004/livefactura/getCodigoAgrupadorSecond/?code=' + code)
    .then((result) => {

        console.log( "Codigo = " + JSON.stringify( result) ) ;

        //fillSelect( result.data ) ;

        setCodigos( result.data )

        setCero( result.data[0].nombre )

        console.log( "******"  + codigos.length )

        //setTimeout( () => { console.log( codigos.length ) }, 2000) // setNameCodigo( codigos[0].nombre ) 

        handleOnChange( result.data[0].codigo)
        
    }).catch((err) => {

        console.log( err ) ;
        
    });

        


    }, [])


    useEffect(() =>{

        console.log( "useEffect")

        if( cero===undefined)
        {return ;}

        console.log( "cero = " + cero ) ;

        setNameCodigo( cero ) ;


    } ,[cero])


    function fillSelect(response)
    {
        var select = document.getElementById('tercer') ;

        while( select.length > 0 )
        {
            select.remove( select.length -1 ) ;
        }
    
        for( var i = 0 ; i < response.length ; i++)
        {
           
    
            var option = document.createElement("option");
            option.value = response[i].codigo;
            option.text =  response[i].codigo  ;

            select.appendChild(option)
    
        }

    }
    
    // , width :'600px'

  return (
    

<div className='box-login float-end' id="theDiv" style={{ top:'10%' , 
        right:'35%' , backgroundColor :'lightgray' , borderRadius:'20px' ,  
        position : 'fixed' , zIndex : 2 }} >

    {

        !showAddClient && (


    <div className='d-flex flex-column align-items-center' 
        style={{borderWidth:2 , borderColor :'black' , fontFamily : 'Satoshi-Bold'}}>

        <div>
            <p className='tx-color-purple body-1 mt-2'>Codigo Tercer Nivel</p>
        </div>

        <div className='display-label-none  w-100'>                    

            <form id='myForm form-2'  style={{color:'black'}}>
        
                <div className="form-outline m-4 mt-1 mb-1 " >
                    <label className="form-label" htmlFor="codigo" >Codigo</label>
                    <input readOnly type="text" id="codigo" value={code}
                    className="form-control" placeholder="Codigo" />
                    
                </div>




                <div className="form-group m-4 mt-1 mb-1">
                    <label for="basic-url">Tercer Nivel</label>
                    <div class="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text" id="tercer1" >{code}</span>
                        </div>
                        <input type="text"   className="form-control" onChange={(val) => handleOnChange(val)} 
                            id="tercer" aria-describedby="basic-addon3" />
                    </div>
                </div>

            {
                showCliente && (

                    <div className='row g-0'>
                        <div className='col-11'>
                           
                            <div style={{margin : '20px'}}>
                                <select id="select" onChange={onChangeSelect} class="form-select" aria-label="Default select example">
                                <option selected>Seleccione Cliente</option>
                                <option value="1">Cliente01</option>
                                <option value="2">Cliente02</option>
                                <option value="3">Cliente03</option>
                                </select>
                            </div>
                        </div> 

                        <div className='col-1 pt-3 pe-2' >
                            <FontAwesomeIcon onClick={onAddClient} title='Agrega Cliente' icon={faPlus}></FontAwesomeIcon>
                        </div>

                        {/* <div className='col-1' >
                        </div> */}
                    
                    </div>
                )


            }




                <div className="form-outline m-4 mt-1 mb-1 " >
                    <label className="form-label" htmlFor="nombre" >Nombre</label>
                    <input  type="text" 
                    id="nombre" className="form-control ms-0" placeholder="Nombre" />
                    
                </div>


                <div className="form-outline m-4 mt-1 mb-1 " >
                    <label className="form-label" htmlFor="comentario" >Comentario</label>
                    <textarea  type="textarea" 
                    id="comentario" className="form-control" placeholder="Comentario" />
                    
                </div>


                {
                    ( naturaleza === "A" || naturaleza === "D" )&& (

                        <div className='m-4 mt-2 mb-1'>
                            <div className='row' >
                                <div className='col-4'>
                                    <p>Naturaleza</p>
                                </div>
                                <div className='col-4'>
                                    <p>{(naturaleza === "A" ? "Acredor" : "Deudor")}</p>
                                </div>
                            </div>
                        </div>
                    )
                }


                <div className='m-4 mt-1 mb-1'>

                <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name='tip' 
                        id="tipor" onChange={() => setTipo('R')}
                        value="option1" checked={tipo==='R'}/>
                    <label className="form-check-label" for="tipor">Resumen</label>
                </div>

                <div className="form-check form-check-inline">
                    <input className="form-check-input" type="radio" name='tip' 
                        id="tipod" onChange={() => setTipo('D')}
                        value="option2" checked={tipo==='D'}/>
                    <label className="form-check-label" for="tipod">Detalle</label>
                </div>



                </div>






                <div className='row'>


                    <div className='col-5'>
                        <button type="button" onClick={askBefore} className="button-2 m-4">Guardar</button>
                    </div>
                    <div className='col-1'>

                    </div>
                    

                    <div className='col-4'>
                        <button type="button" onClick={exitadd} className="button-2 m-4">Salir</button>
                    </div>

                    <div className='col-2'>

                    </div>
                    
                </div>
            </form>
        </div>
    </div>
                
                )
            }

    {/* {
        showAddClient && (
            <AddClient closeClient={onCloseClient}></AddClient>
        )
    } */}


        <Modal 
            isOpen={modalIsOpen}
            onAfterOpen={afterOpenModal}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Example Modal"
            
        
        >
            <div>            
                <h5 ref={(_subtitle) => (subtitle = _subtitle)}>Agregar {clientTitle}</h5>
                <AddClient closeClient={onCloseClient} clientTitle={clientTitle}></AddClient>
            </div>


        </Modal>


        <Modal 
            isOpen={modalIsOpen2}
            onAfterOpen={afterOpenModal2}
            onRequestClose={closeModal2}
            style={customStyles2}
            contentLabel="Example Modal"
            
        
        >
            <div >

            
                <div>            
                    <h5 ref={(_subtitle) => (subtitle = _subtitle)}>Agregar cuenta</h5>
                    <p>{message}</p>
                </div>

                <div className='row'>

                    <div className='col-6'>
                        <button className='button-2 mt-2' onClick={closeAccept} style={{borderRadius:'10px'}}>Aceptar</button>

                    </div>

                    <div className='col-6'>

                        <button className='button-2 mt-2' onClick={closeReject} style={{borderRadius:'10px'}}>Rechazar</button>

                    </div>

                </div>

            </div>


        </Modal>


</div>

  )
}

export default AddThird